import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from './api';

export const DEFAULT_CONTENT = {
  hero: {
    headline_line1: 'HIGGINS',
    headline_line2: 'TRUCK SALES',
    subheading: 'Quality Used Trucks & Trailers Ready For Work',
    points: ['Prime Movers', 'Rigids', 'Trailers', 'Transport Equipment'],
    primary_button: 'VIEW CURRENT STOCK',
    secondary_button: 'CONTACT US',
    image_url: '/images/hero-roadtrain.webp',
  },
  why_choose: [
    { title: 'INDUSTRY EXPERIENCE', text: 'Years of experience in the transport and logistics industry.' },
    { title: 'QUALITY VEHICLES', text: 'Carefully inspected, reliable trucks and trailers.' },
    { title: 'NATIONWIDE ENQUIRIES', text: 'We work with customers across Australia.' },
  ],
  contact: {
    phone: '0477 790 299',
    email: 'warrick@higginsservices.com.au',
    address: '1-17 Moorebank Rd, Charlton, Toowoomba QLD',
    hours: 'Monday - Friday: 8:00am - 5:00pm\nSaturday: By Appointment',
  },
  about: {
    paragraph1:
      'Higgins Truck Sales is part of Higgins Services, a trusted name in the transport and logistics industry.',
    paragraph2:
      'We are committed to providing quality trucks and trailers at competitive prices with honest, reliable service. Every vehicle we list is carefully inspected and ready to work.',
    bullets: ['Quality inspected vehicles', 'Competitive pricing', 'Nationwide delivery options', 'Dedicated support'],
    image_url: '/images/about-kenworth.webp',
  },
  cta: {
    heading: 'LOOKING FOR YOUR NEXT TRUCK?',
    subtext: "Get in touch with our team today - we'll help you find the right vehicle for the job.",
    button: 'CONTACT US TODAY',
  },
  footer: {
    blurb:
      'Part of Higgins Services - a trusted name in the transport and logistics industry. Quality trucks and trailers available across Australia.',
  },
};

const ContentContext = createContext({ content: DEFAULT_CONTENT, refresh: () => {} });

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(DEFAULT_CONTENT);

  const refresh = useCallback(() => {
    api
      .get('/content')
      .then((res) => setContent(res.data))
      .catch(() => {});
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return <ContentContext.Provider value={{ content, refresh }}>{children}</ContentContext.Provider>;
};

export const useContent = () => useContext(ContentContext).content;
export const useContentRefresh = () => useContext(ContentContext).refresh;
